import React from 'react';
import translate from '@/utils/translate';
import {ONBOARDING_STEPS, OnboardingStep} from '../onboardingSteps';
import styles from '../onboardingWizard.module.scss';
import FeatureSelectionAssetDisplay from '../steps/FeatureSelection/FeatureSelectionAssetDisplay';

type StepData = {
  title: string;
  description: string;
  renderImage: () => React.ReactNode;
};

export default function getStepData(step: OnboardingStep): StepData {
  const getStepDataByStepMap = {
    [ONBOARDING_STEPS.CONSENT_FORM]: {
      title: 'Review & Accept Ltx Scaler Terms ',
      description: '',
      renderImage: () => (
        <img
          src="/assets/images/content-studio/onboarding/content-agreement-wide.jpg"
          alt="Content agreement"
          className={styles.desktopVisual}
        />
      ),
    },
    [ONBOARDING_STEPS.FEATURE_SELECTION]: {
      // title: translate('What do you want to do first?'),
      // description: translate('Choose a tool to kick off your first project'),
      title: '',
      description: '',
      renderImage: FeatureSelectionAssetDisplay,
    },
  };
  return getStepDataByStepMap[step];
}
